'use client';

import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";

export function AuditPanel({ contentId }: { contentId: string }) {
  const [items, setItems] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const res = await fetch(`/api/cms/content/${contentId}/audit`);
      const data = await res.json();
      setItems(Array.isArray(data.items) ? data.items : []);
    })();
  }, [contentId]);

  return (
    <div className="bg-grayCustom rounded ">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="w-full flex items-center justify-between px-3 py-2 text-xs uppercase tracking-wide opacity-70 hover:opacity-100 transition"
      >
        <span>Activity</span>
        <motion.span
          aria-hidden="true"
          className="text-base leading-none select-none"
          initial={false}
          animate={{ rotate: open ? 0 : 90, scale: open ? 1 : 0.95, opacity: 0.9 }}
          transition={{ type: "spring", stiffness: 400, damping: 24 }}
        >
          {open ? "−" : "+"}
        </motion.span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: 0, opacity: 0 },
            }}
            transition={{ duration: 0.28, ease: [0.22, 0.61, 0.36, 1] }}
            className="overflow-hidden"
          >
            <div className="max-h-[50vh] overflow-auto px-3 pb-3">
              <motion.ul
                className="space-y-2"
                variants={{
                  open: {
                    transition: { staggerChildren: 0.04, delayChildren: 0.06 },
                  },
                  collapsed: {
                    transition: { staggerChildren: 0.02, staggerDirection: -1 },
                  },
                }}
              >
                {items.length === 0 ? (
                  <motion.li
                    className="text-sm opacity-60"
                    variants={{
                      open: { y: 0, opacity: 1 },
                      collapsed: { y: -6, opacity: 0 },
                    }}
                    transition={{ type: "spring", stiffness: 350, damping: 28 }}
                  >
                    No activity yet.
                  </motion.li>
                ) : (
                  items.map((item: any) => (
                    <motion.li
                      key={item.id}
                      className="text-sm"
                      variants={{
                        open: { y: 0, opacity: 1 },
                        collapsed: { y: -6, opacity: 0 },
                      }}
                      transition={{ type: "spring", stiffness: 350, damping: 28 }}
                    >
                      <span className="opacity-70">
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString()
                          : ""}
                      </span>{" "}
                      <strong>{item.action}</strong>{" "}
                      {item.actorId ? (
                        <span className="opacity-70">by {item.actorId}</span>
                      ) : null}
                      {item.notes ? (
                        <span className="opacity-70"> — {item.notes}</span>
                      ) : null}
                    </motion.li>
                  ))
                )}
              </motion.ul>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
